"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function Square(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { d: "M19 3c.522 0 1.055.191 1.432.568.377.377.568.91.568 1.432v14c0 .522-.191 1.055-.568 1.432-.377.377-.91.568-1.432.568H5c-.522 0-1.055-.191-1.432-.568C3.191 20.055 3 19.522 3 19V5c0-.522.191-1.055.568-1.432C3.945 3.191 4.478 3 5 3zm0 2H5v14h14V5zm-7.037 2c.966 0 1.733.25 2.3.749.568.499.852 1.176.852 2.033 0 .483-.121.912-.363 1.285a2.608 2.608 0 0 1-.998.896c.483.232.866.552 1.149.96.282.408.424.888.424 1.44 0 .883-.301 1.582-.903 2.095-.601.512-1.42.769-2.454.769-1.034 0-1.855-.258-2.46-.773-.607-.515-.91-1.212-.91-2.092 0-.551.141-1.032.424-1.442.282-.41.663-.73 1.141-.957a2.581 2.581 0 0 1-.994-.896 2.331 2.331 0 0 1-.36-1.285c0-.847.283-1.523.849-2.027.565-.503 1.333-.755 2.303-.755zm-.007 5.79c-.419 0-.754.129-1.004.386-.251.258-.376.605-.376 1.043 0 .424.123.765.369 1.025.246.26.588.39 1.025.39.429 0 .765-.126 1.008-.376.244-.25.366-.597.366-1.04 0-.432-.125-.779-.376-1.038-.25-.26-.588-.39-1.012-.39zm.007-4.197c-.369 0-.656.114-.861.342-.205.227-.308.542-.308.943 0 .396.103.715.308.957.205.241.494.362.868.362s.662-.12.865-.362c.203-.242.304-.56.304-.957 0-.387-.102-.698-.308-.933-.205-.235-.494-.352-.868-.352z", fill: props.color || "#000", fillRule: "nonzero" })));
}
exports.default = Square;
